import { render, staticRenderFns } from "./CoverSummaryReview.vue?vue&type=template&id=86da2754&scoped=true"
import script from "./CoverSummaryReview.vue?vue&type=script&lang=js"
export * from "./CoverSummaryReview.vue?vue&type=script&lang=js"
import style0 from "./CoverSummaryReview.vue?vue&type=style&index=0&id=86da2754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86da2754",
  null
  
)

export default component.exports